const RegEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d!@#$%^&*]{8,16}$/i;
export const PHONE_REGEXP = /^[6789]\d{9}$/;
const ONLY_ALPHABATE = /^[A-Za-z\s]*$/;
const ONLY_TEXT_N_SPACE = /[^A-Za-z\s]/g;
const ONLY_ALPHA_NUMERIC = /[^a-zA-Z0-9]/g;
const ONLY_PDF = /^(https?|ftp):\/\/[^\s\/$.?#].[^\s]*\.pdf$/i;
const ONLY_EMAIL = /^[a-zA-Z0-9_.]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}$/;

export function validateLogin(values) {
    var errors = {};
    if (!values?.Email) {
        errors.Email = "Email Required";
    } else if (!RegEmail.test(values.Email)) {
        errors.Email = "Invalid email address";
    }
    if (!values?.Password) {
        errors.Password = "Password Required";
    }
    // if (!values?.Token) {
    //     errors.Token = "Verify Captcha Required";
    // }
    return errors;
}
export function validateForgetPassword(values) {
    var errors = {};
    if (!values?.Email) {
        errors.Email = "Email Required";
    } else if (!RegEmail.test(values.Email)) {
        errors.Email = "Invalid email address";
    }
    return errors;
}
export function newValidateLogin(values) {
    var errors = {};
    if (!values?.Email) {
        errors.Email = "Email Required";
    } else if (!RegEmail.test(values.Email)) {
        errors.Email = "Invalid email address";
    }
    if (!values?.Password) {
        errors.Password = "Password Required";
    }
    return errors;
}
export const PasswordRule = (Label = "Password") =>
    [
        { required: true, message: `${Label} is required` },
        { min: 8, message: `${Label} must have a min length of 8 character` },
        {
            pattern: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?&])[A-Za-z\\d@$!%*?&]{8,}$'),
            message: `${Label} must contain at least one lowercase letter, uppercase letter, number, and special character`
        },
        {validator:ValidateCommonPass}
       /*  { max: 16, message: `${Label} must have a max length of 16 character` } */
    ]
export const ValidatePhone = (_, value) => {
    if (value && value?.length > 0 && !PHONE_REGEXP.test(value)) {
        return Promise.reject(new Error("Enter Valid Mobile Number"));
    } else {
        return Promise.resolve();
    }
};
export const ValidateOnlyPdfUrl = (_, value) => {
    if (value && value?.length > 0 && !ONLY_PDF.test(value)) {
        return Promise.reject(new Error("Enter only valid pdf file"));
    } else {
        return Promise.resolve();
    }
};
export const ValidateEmail = (_, value) => {
    if (value && value?.length > 0 && !ONLY_EMAIL.test(value)) {
        return Promise.reject(new Error("Enter valid email"));
    } else {
        return Promise.resolve();
    }
};
export const ValidateCommonPass = (_, value) => {
    if (value && value?.length > 0 && value?.includes("Password@123")) {
        return Promise.reject(new Error("You enter commonly passwords."));
    } else {
        return Promise.resolve();
    }
};
export const onlyTextandSpaceFilter = (e) => {
   return e.target.value = e.target.value?.replace(ONLY_TEXT_N_SPACE,'')?.replace(/<\/?[^>]+(>|$)/g, "");
};
export const onlyAlphaNumericFilter = (e) => {
   return e.target.value = e.target.value?.replace(ONLY_ALPHA_NUMERIC,'')?.replace(/<\/?[^>]+(>|$)/g, "");
};
export const preventHtml = (e) => {
    return e.target.value = e.target.value?.replace(/<\/?[^>]+(>|$)/g, "")
}
function notJson (data) {
    try {
        const parsedData = JSON.parse(data);
        return false
      } catch (error) {
        return true
      }
}
export const ValidateOnlyJson = (_, value) => {
    if (value && notJson(value)) {
        return Promise.reject(new Error("Invalid JSON data"));
    } else {
        return Promise.resolve();
    }
};